import { Component, Inject, PLATFORM_ID, signal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-mobile-app-prompt',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-app-prompt.component.html',
  styleUrl: './mobile-app-prompt.component.scss',
})
export class MobileAppPromptComponent {
  showPrompt = signal(false);

  private readonly STORAGE_KEY = 'dismissedMobilePrompt';
  private readonly APPLE_URL =
    'https://itunes.apple.com/ug/app/nssf-go/id1049818695?mt=8';
  private readonly ANDROID_URL =
    'https://play.google.com/store/apps/details?id=org.nssf.go';

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      const dismissed = sessionStorage.getItem(this.STORAGE_KEY);
      if (!dismissed && this.isMobile()) {
        this.showPrompt.set(true);
      }
    }
  }

  downloadApp(): void {
    const url = this.isIOS() ? this.APPLE_URL : this.ANDROID_URL;
    window.open(url, '_blank');
  }

  continueOnWeb(): void {
    sessionStorage.setItem(this.STORAGE_KEY, 'true');
    this.showPrompt.set(false);
  }

  private isMobile(): boolean {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      ua,
    );
  }

  private isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}
